import React from "react";
import PropTypes from "prop-types";

const DpdCircleBox = ({
  className
}) => /*#__PURE__*/React.createElement("svg", {
  className: className,
  width: "47",
  height: "46",
  viewBox: "0 0 47 46",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/React.createElement("mask", {
  id: "mask0_2012_7814",
  style: {
    maskType: "alpha"
  },
  maskUnits: "userSpaceOnUse",
  x: "11",
  y: "8",
  width: "25",
  height: "30"
}, /*#__PURE__*/React.createElement("rect", {
  x: "11.5",
  y: "8.85718",
  width: "24",
  height: "28.2857",
  fill: "#C4C4C4"
})), /*#__PURE__*/React.createElement("g", {
  mask: "url(#mask0_2012_7814)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M34.8128 14.9814L34.4816 15.192C32.0791 16.6072 29.6831 18.0289 27.274 19.4374C26.988 19.5679 26.8194 19.8723 26.8585 20.1878C26.9039 21.0303 26.8585 20.925 27.5468 21.3594C27.791 21.5529 28.1316 21.561 28.3844 21.3792C30.5921 20.0627 32.8129 18.7463 35.0206 17.4299L35.4232 17.1996C35.4281 17.2916 35.4281 17.3839 35.4232 17.476V29.5277C35.4318 29.9367 35.2031 30.3128 34.8388 30.4887L27.3714 34.9711C26.287 35.6293 25.1962 36.2875 24.1248 36.9457C23.7449 37.2086 23.2449 37.2086 22.8651 36.9457C19.2937 34.7868 15.7224 32.6454 12.151 30.5216C11.7312 30.3059 11.4766 29.8593 11.5017 29.3829C11.5017 25.4337 11.5017 21.5042 11.5017 17.5945C11.5017 17.476 11.5017 17.3641 11.5017 17.1996L11.8588 17.397L22.0209 23.3867C22.2524 23.4887 22.3917 23.7312 22.3651 23.9856C22.3651 26.9081 22.3651 29.8239 22.3651 32.7463V33.0425C22.3566 33.2376 22.464 33.419 22.6378 33.5033L23.1832 33.8126C23.3549 33.918 23.57 33.918 23.7417 33.8126L24.2611 33.523C24.4483 33.4417 24.5633 33.2483 24.5468 33.0425C24.5468 32.9636 24.5468 32.8846 24.5468 32.8056V22.8799C24.5468 22.7877 24.5468 22.7021 24.5468 22.61C24.553 22.4293 24.4573 22.2608 24.3001 22.1756L23.4754 21.6885L12.4887 15.192L12.151 14.988L12.4238 14.7971L22.8131 9.0444C23.211 8.79477 23.7139 8.79477 24.1118 9.0444C27.5857 10.9795 31.0467 12.8817 34.5076 14.7971L34.8128 14.9814Z",
  fill: "url(#paint0_linear_2012_7814)"
})), /*#__PURE__*/React.createElement("rect", {
  x: "1",
  y: "0.5",
  width: "45",
  height: "45",
  rx: "22.5",
  stroke: "black",
  strokeOpacity: "0.3"
}), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint0_linear_2012_7814",
  x1: "23.558",
  y1: "18.0508",
  x2: "12.6969",
  y2: "30.0132",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#DC0032"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "0.2",
  stopColor: "#D0012D"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "0.4",
  stopColor: "#C30229"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "0.6",
  stopColor: "#B70324"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "0.8",
  stopColor: "#AB041F"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "1",
  stopColor: "#9F041B"
}))));

DpdCircleBox.propTypes = {
  className: PropTypes.string
};
export default DpdCircleBox;